import { property } from 'lit/decorators.js';
import { html } from 'lit';
import { customElement } from '@thiememeulenhoff/lit-sdk';
import { MediaPlayerBaseComponent } from '../media-player.component';
import { styles } from './audio.styles';
import { baseStyles } from '../media-player.styles';
import { tagName } from '../../../helpers';

const tag = tagName('audio-player');

@customElement(tag)
export class MediaPlayerAudioComponent extends MediaPlayerBaseComponent {
  static override styles = [baseStyles, styles];

  override bbwPlayout = 'basic_msp20_responsive_redesign_for_audio';

  @property({ type: Boolean })
  fixedWidth = false;

  override connectedCallback() {
    super.connectedCallback();

    if (!this.usePlaceholder) {
      this.initPlayer();
    }
  }

  override render() {
    return html`
      ${
        !this.playerLoaded
          ? html`<a-loader>Aan het laden...</a-loader>`
          : html`<div class="player-container">
              ${this.placeholderTemplate()}
            </div>`
      }
    `;
  }

  placeholderTemplate() {
    if (!this.usePlaceholder) {
      return html``;
    }

    return html`<div class="placeholder-container">
      <button class="placeholder-button" @click="${this.initPlayer}">
        <a-icon name="play"></a-icon>
      </button>
      <div class="placeholder-progress">
        <div class="placeholder-progress-bar"></div>
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-audio-player': MediaPlayerAudioComponent;
  }
}
